import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import commonClasses from './SubscriptionCard.module.scss';
import pingoClasses from './styles/pingo.module.scss';
import logicLikeClasses from './styles/logicLike.module.scss';
import musicClasses from './styles/music.module.scss';
import kionClasses from './styles/kion.module.scss';
import leoniClasses from './styles/leoni.module.scss';
import launcherClasses from './styles/launcher.module.scss';
import { BackArrowIcon } from '@icons';
import { useWindowSize } from '@hooks/useWindowSize';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { versionSelector } from '@store/models/user/selectors';
import { triggerMetricsEvent } from '@metrics';
import { isSubscriptionActiveSelector, subscriptionStatusesSelector } from '@store/models/subscription/selectors';
import Picture from '@shared/Picture/Picture';
const classesMap = {
    pingo: pingoClasses,
    logicLike: logicLikeClasses,
    music: musicClasses,
    kion: kionClasses,
    leoni: leoniClasses,
    launcher: launcherClasses,
};
const SubscriptionCard = ({ element }) => {
    const version = useSelector(versionSelector);
    const { parent: { active: isParentActive, draft: isParentDraft, childAdd: isChildAdd }, child: { active: isChildActive }, } = useSelector(subscriptionStatusesSelector);
    const { isMobileSm, isDesktop } = useWindowSize();
    const navigate = useNavigate();
    const isLauncher = element.name === 'launcher';
    const isSubscriptionActive = useSelector(isSubscriptionActiveSelector);
    const showPrice = !isSubscriptionActive;
    const { alt: iconAlt, src: iconSrc } = isDesktop && element.icon.desktop ? element.icon.desktop : element.icon.mobile;
    const { alt: imgAlt, src: imgSrc } = isDesktop ? element.img.desktop : element.img.mobile;
    const handleClick = () => {
        const isSubscriptionActive = (isParentDraft && isChildActive) || isParentActive || isChildAdd;
        const cardMetricName = isSubscriptionActive ? `${element.name}Active` : element.name;
        triggerMetricsEvent({ element: cardMetricName });
        if (element.link.isExternal) {
            window.location.href = element.link.href;
            return;
        }
        navigate(element.link.href);
    };
    const classes = classesMap[element.name];
    const cardClasses = classNames(commonClasses.card, classes.card, commonClasses[version], {
        [commonClasses.withoutPrice]: !showPrice,
    });
    const title = _jsx("h3", { className: classNames(commonClasses.title, classes.title), children: element.title });
    const getBadge = (text) => {
        return (_jsx("div", { className: commonClasses.badgeContainer, children: _jsx("div", { className: classNames(commonClasses.badge, classes.badge), children: text }) }));
    };
    return (_jsxs("div", { className: cardClasses, onClick: handleClick, children: [_jsx("div", { className: classNames(commonClasses.bubbleContainer, classes.bubbleContainer) }), (!isMobileSm || isLauncher) && (_jsx(Picture, { alt: imgAlt, src: imgSrc, containerClass: classNames(commonClasses.imgContainer), className: commonClasses.img })), _jsxs("div", { className: commonClasses.iconContainer, children: [_jsx("img", { className: commonClasses.icon, alt: iconAlt, src: `/images/${iconSrc.directory}/${iconSrc.fileName}` }), !isMobileSm && title] }), !isMobileSm && element.badge?.desktop && getBadge(element.badge.desktop), _jsxs("div", { className: classNames(commonClasses.textContainer, classes.textContainer), children: [isMobileSm && !isLauncher && title, _jsx("p", { className: commonClasses.text, children: isMobileSm ? element.text.mobile : element.text.desktop })] }), !(isMobileSm && isLauncher) && (_jsxs("div", { className: classNames(commonClasses.priceContainer, {
                    [commonClasses.withNote]: element.note,
                }), children: [element.price && showPrice && _jsx("span", { className: commonClasses.price, children: element.price }), element.note && _jsx("span", { className: commonClasses.note, children: element.note }), _jsx(BackArrowIcon, { containerClasses: commonClasses.arrowIcon })] })), isMobileSm && element.badge?.mobile && getBadge(element.badge.mobile)] }));
};
export default SubscriptionCard;
